import { assert } from '../../lib/assert-sidecar'
import { l } from '../../lib/imports'
import { createId } from '../../main/common'
import { common } from '../../main/common-sidecar'
import { EVoyageCrewCarryCommand } from './multi/voyageMessageCrewCarry'
import { voyageMessageCrewCarry } from './multi/voyageMessageCrewCarry-sidecar'
import { EVoyageCarryableType } from './voyageCarryableData'
import { voyageCarryableData } from './voyageCarryableData-sidecar'
import type { IVoyageCrew } from './voyageCrew'
import type { IVoyageSystemState } from './voyageSystems'
import { voyageTilemap } from './voyageTilemap-sidecar'
import type { IVoyageTilemapPart } from './voyageTilemapPart'
import { voyageWebsockets } from './voyageWebsockets-sidecar'

export function onCreate(
  sys: IVoyageSystemState,
  text3: string,
  t: IVoyageTilemapPart,
) {
  // Try to spawn item
  let code = text3.substring(sys.data.startsWith.length + 1)
  let data = voyageCarryableData.tryFindByCode(code)
  if (data) {
    // console.log('CARRY', 'Create')
    if (voyageWebsockets.getIsHost()) {
      voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
        command: EVoyageCrewCarryCommand.Create,
        type: data.type,
        crewId: 0,
        carryId1: createId(),
        carryId2: 0,
        i: t.i,
        j: t.j,
      })
    }

    // let cy = voyageCarryable.create(data.type)
    // voyageCarryable.setAtTile(cy, t)
  }
}

export function onEnter(obj: IVoyageCrew, isFinalMove: boolean) {
  if (isFinalMove) {
    swapItemHere(obj, true)
  }
}

export function swapItemHere(obj: IVoyageCrew, doPutDown: boolean) {
  let ds = common.getUpdateDeltaScaled()
  let d = obj.crewState
  assert.notNil(d)

  let tHere = voyageTilemap.getSafeIJ(obj)
  if (tHere) {
    let item1 =
      l.find(obj.items, (c) => c.type !== EVoyageCarryableType.Coffee) || null
    let item2 = tHere.items[0] || null

    if (voyageWebsockets.getIsHost()) {
      if (item1 && !item2) {
        if (item1.data.type === EVoyageCarryableType.Coffee) {
          return // Can't place down coffee
        }
        // console.log('CARRY', 'Drop')
        if (doPutDown) {
          voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
            command: EVoyageCrewCarryCommand.Drop,
            type: item1.type,
            crewId: obj.id,
            carryId1: item1.id,
            carryId2: 0,
            i: obj.i,
            j: obj.j,
          })
        }
      }

      if (item1 && item2) {
        if (item1.data.type === EVoyageCarryableType.Coffee) {
          return // Can't swap coffee
        }
        // console.log('CARRY', 'Swap')
        voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
          command: EVoyageCrewCarryCommand.Swap,
          type: item2.type,
          crewId: obj.id,
          carryId1: item1.id,
          carryId2: item2.id,
          i: obj.i,
          j: obj.j,
        })
      }
      if (!item1 && item2) {
        // Pickup
        //console.log('CARRY', 'Pickup')
        voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
          command: EVoyageCrewCarryCommand.Pickup,
          type: item2.type,
          crewId: obj.id,
          carryId1: item2.id,
          carryId2: 0,
          i: obj.i,
          j: obj.j,
        })
      }
    }
  }
}
